import React from 'react';
import Modal from './Modal';
import Manager from './Manager';
import FSButton from '@components/FSButton';
import ModalHeader from './ModalHeader';
import { useLanguage } from '@base/LanguageProvider';
import { ModalBody, ModalFooterStyled } from '@styled/Modal';
function Confirmation(_a) {
    var width = _a.width, title = _a.title, children = _a.children, yesBtn = _a.yesBtn, loading = _a.loading, onOk = _a.onOk, onCancel = _a.onCancel;
    var L = useLanguage().L;
    function ok() {
        onOk();
        Manager.closeModal();
    }
    function cancel() {
        if (onCancel) {
            onCancel();
        }
        Manager.closeModal();
    }
    return (React.createElement(Modal, { width: "".concat(width) },
        React.createElement(ModalHeader, { title: title }),
        React.createElement(ModalBody, null, children),
        React.createElement(ModalFooterStyled, null,
            React.createElement(FSButton, { "$type": "tertiary", title: L('Close'), onClick: cancel, loading: loading }),
            React.createElement(FSButton, { title: yesBtn ? yesBtn : L('Yes'), onClick: ok, loading: loading }))));
}
export { Confirmation };
